module.exports = __webpack_public_path__ + "img/ian.4fe18c66.jpg";